// custom start
(function () {
	const BP = 990;

	const stopVideo = (section) => {
		section.querySelectorAll('video').forEach((video) => {
			video.pause();
		});
	};

	const playVideo = (section) => {
		const cards = section.querySelectorAll('.gallery-with-text__card');
		cards.forEach((card) => {
			const video = card.querySelector('video');
			if (!video) return;
			if (card.classList.contains('active')) {
				video.play().catch(() => {});
			} else {
				video.pause();
			}
		});
	};

	const updateWidthSlide = (section) => {
		if (!section) return;
		let widthSlide = '100%';
		if (document.documentElement.clientWidth >= BP) {
			const activeCard = section.querySelector('.gallery-with-text__card.active');
			if (activeCard) {
				widthSlide = `${activeCard.getBoundingClientRect().width}px`;
			}
		}
		section.style.setProperty('--width-slide', widthSlide);
	};

	const galleryTextSlide = () => {
		const activateCard = function () {
			if (!window.matchMedia(`(min-width: ${BP}px)`).matches) return;

			const $this = $(this);
			$this.addClass('active');
			$this.siblings('.gallery-with-text__card').removeClass('active');
			setTimeout(function () {
				$this.children('.gallery-with-text__info').children('.link--overlay').addClass('active');
				$this
					.siblings('.gallery-with-text__card')
					.children('.gallery-with-text__info')
					.children('.link--overlay')
					.removeClass('active');
			}, 100);

			const section = $this.closest('.gallery-with-text-section')[0];
			requestAnimationFrame(() => updateWidthSlide(section));
			window.setTimeout(() => updateWidthSlide(section), 850);
			playVideo(section);
		};

		$('.gallery-with-text__card')
			.off('mouseenter.galleryWithText')
			.off('click.galleryWithText')
			.on('mouseenter.galleryWithText', activateCard)
			.on('click.galleryWithText', function (event) {
				if (event.target.closest('a')) return;
				activateCard.call(this);
			});
	};

	class GalleryWithTextCarousel {
		constructor(section) {
			this.section = section;
			this.root = section.querySelector('[data-gallery-with-text-root]');
			this.slider = section.querySelector('[data-gallery-slider]');
			this.wrapper = this.slider ? this.slider.closest('.gallery-with-text__wrapper') : null;
			this.dotsWrap = section.querySelector('[data-gallery-dots]');
			this.dots = section.querySelectorAll('[data-gallery-dot]');
			this.cards = section.querySelectorAll('.gallery-with-text__card');
			this.count = this.cards.length;
			this.index = 0;
			this.timer = null;
			this._slideWidth = 0;
			this._lastLayoutW = 0;
			this._wrapperRo = null;
			this._onResize = this._onResize.bind(this);
			this._onWrapperResize = this._onWrapperResize.bind(this);
			this._onVisibility = this._onVisibility.bind(this);
			this._onDotClick = this._onDotClick.bind(this);
			this._touch = { startX: 0, dx: 0, tracking: false };
			this._onTouchStart = this._onTouchStart.bind(this);
			this._onTouchMove = this._onTouchMove.bind(this);
			this._onTouchEnd = this._onTouchEnd.bind(this);
		}

		isMobile() {
			return window.matchMedia(`(max-width: ${BP - 1}px)`).matches;
		}

		_autoplayEnabled() {
			if (!this.root) return false;
			return this.root.getAttribute('data-autoplay') === 'true';
		}

		_intervalMs() {
			if (!this.root) return 5000;
			const raw = parseInt(this.root.getAttribute('data-autoplay-interval-ms'), 10);
			return Number.isFinite(raw) && raw >= 1000 ? raw : 5000;
		}

		_reducedMotion() {
			return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		}

		_clearCarouselLayout() {
			this._lastLayoutW = 0;
			this._slideWidth = 0;
			if (!this.slider) return;
			this.slider.style.width = '';
			this.slider.style.transform = '';
			this.slider.style.transition = '';
			this.cards.forEach((card) => {
				card.style.flex = '';
				card.style.minWidth = '';
				card.style.maxWidth = '';
			});
		}

		_layoutCarousel() {
			if (!this.slider || !this.wrapper || !this.isMobile()) return;
			const w = Math.max(1, Math.round(this.wrapper.getBoundingClientRect().width));
			if (w === this._lastLayoutW && this.slider.style.width) return;
			this._lastLayoutW = w;
			this._slideWidth = w;
			this.slider.style.width = `${w * this.count}px`;
			this.cards.forEach((card) => {
				card.style.flex = `0 0 ${w}px`;
				card.style.minWidth = `${w}px`;
				card.style.maxWidth = `${w}px`;
			});
		}

		goToSlide(i, animate) {
			if (!this.slider || this.count < 1) return;
			const next = ((i % this.count) + this.count) % this.count;
			this.index = next;

			if (this.isMobile()) {
				this._layoutCarousel();
				const fallbackW =
					this.wrapper && this.wrapper.getBoundingClientRect
						? Math.max(1, Math.round(this.wrapper.getBoundingClientRect().width))
						: 1;
				const step = this._slideWidth || fallbackW;
				const x = -next * step;
				if (animate === false) {
					this.slider.style.transition = 'none';
				} else {
					this.slider.style.transition = '';
				}
				this.slider.style.transform = `translate3d(${x}px, 0, 0)`;
				if (animate === false) {
					void this.slider.offsetWidth;
					this.slider.style.transition = '';
				}
			} else {
				this.slider.style.transform = '';
				this.slider.style.transition = '';
			}

			this.cards.forEach((card, idx) => {
				const active = idx === next;
				card.classList.toggle('active', active);
				const overlay = card.querySelector('.link--overlay');
				if (overlay) overlay.classList.toggle('active', active);
			});

			requestAnimationFrame(() => updateWidthSlide(this.section));

			this.dots.forEach((dot, idx) => {
				dot.setAttribute('aria-selected', idx === next ? 'true' : 'false');
			});

			playVideo(this.section);
		}

		_startAutoplay() {
			this._stopAutoplay();
			if (
				this.count < 2 ||
				!this.isMobile() ||
				!this._autoplayEnabled() ||
				this._reducedMotion()
			) {
				return;
			}
			this.timer = window.setInterval(() => {
				this.goToSlide(this.index + 1, true);
			}, this._intervalMs());
		}

		_stopAutoplay() {
			if (this.timer) {
				window.clearInterval(this.timer);
				this.timer = null;
			}
		}

		_bindDots() {
			this.dots.forEach((dot) => {
				dot.addEventListener('click', this._onDotClick);
			});
		}

		_unbindDots() {
			this.dots.forEach((dot) => {
				dot.removeEventListener('click', this._onDotClick);
			});
		}

		_onDotClick(e) {
			const btn = e.currentTarget;
			const idx = parseInt(btn.getAttribute('data-index'), 10);
			if (!Number.isFinite(idx)) return;
			this._stopAutoplay();
			this.goToSlide(idx, true);
			this._startAutoplay();
		}

		_onResize() {
			if (!this.slider) return;
			if (this.isMobile()) {
				this._lastLayoutW = 0;
				if (this.dotsWrap) this.dotsWrap.hidden = this.count < 2;
				this.goToSlide(this.index, false);
				this._startAutoplay();
			} else {
				this._clearCarouselLayout();
				if (this.dotsWrap) this.dotsWrap.hidden = true;
				this._stopAutoplay();
			}
		}

		_onWrapperResize() {
			if (!this.isMobile() || !this.slider) return;
			this._lastLayoutW = 0;
			this.goToSlide(this.index, false);
		}

		_onVisibility() {
			if (document.hidden) this._stopAutoplay();
			else this._startAutoplay();
		}

		_onTouchStart(e) {
			if (!this.isMobile() || this.count < 2) return;
			const t = e.changedTouches[0];
			this._touch.startX = t.clientX;
			this._touch.tracking = true;
			this._touch.dx = 0;
			this._stopAutoplay();
		}

		_onTouchMove(e) {
			if (!this._touch.tracking) return;
			const t = e.changedTouches[0];
			this._touch.dx = t.clientX - this._touch.startX;
		}

		_onTouchEnd() {
			if (!this._touch.tracking) return;
			this._touch.tracking = false;
			const threshold = 50;
			if (this._touch.dx > threshold) {
				this.goToSlide(this.index - 1, true);
			} else if (this._touch.dx < -threshold) {
				this.goToSlide(this.index + 1, true);
			}
			this._touch.dx = 0;
			this._startAutoplay();
		}

		init() {
			if (!this.slider || this.count < 1) return;

			const startIdx = [...this.cards].findIndex((c) => c.classList.contains('active'));
			this.index = startIdx >= 0 ? startIdx : 0;

			if (this.wrapper) {
				this._wrapperRo = new ResizeObserver(() => {
					requestAnimationFrame(() => this._onWrapperResize());
				});
				this._wrapperRo.observe(this.wrapper);
			}

			window.addEventListener('resize', this._onResize);
			document.addEventListener('visibilitychange', this._onVisibility);
			this._bindDots();
			this.slider.addEventListener('touchstart', this._onTouchStart, { passive: true });
			this.slider.addEventListener('touchmove', this._onTouchMove, { passive: true });
			this.slider.addEventListener('touchend', this._onTouchEnd);

			this._onResize();
		}

		destroy() {
			window.removeEventListener('resize', this._onResize);
			document.removeEventListener('visibilitychange', this._onVisibility);
			this._unbindDots();
			if (this._wrapperRo && this.wrapper) {
				this._wrapperRo.unobserve(this.wrapper);
				this._wrapperRo.disconnect();
				this._wrapperRo = null;
			}
			if (this.slider) {
				this.slider.removeEventListener('touchstart', this._onTouchStart);
				this.slider.removeEventListener('touchmove', this._onTouchMove);
				this.slider.removeEventListener('touchend', this._onTouchEnd);
			}
			this._clearCarouselLayout();
			this._stopAutoplay();
			if (this.dotsWrap) this.dotsWrap.hidden = true;
		}
	}

	const instances = new WeakMap();

	let sectionObserver = null;
	let sectionResizeObserver = null;

	const ensureObservers = () => {
		if (sectionObserver) return;
		sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) playVideo(entry.target);
				else stopVideo(entry.target);
			});
		});
		sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			updateWidthSlide(entry.target);
			playVideo(entry.target);
		});
	};

	const initSection = () => {
		ensureObservers();
		const sections = document.querySelectorAll('.gallery-with-text-section');

		sections.forEach((section) => {
			const prev = instances.get(section);
			if (prev) prev.destroy();

			sectionObserver.observe(section);
			sectionResizeObserver.observe(section);

			const carousel = new GalleryWithTextCarousel(section);
			carousel.init();
			instances.set(section, carousel);
		});

		galleryTextSlide();
	};

	document.addEventListener('shopify:section:load', function () {
		initSection();
	});

	document.addEventListener('shopify:section:unload', function (e) {
		const section = e.target;
		if (!section || !section.classList || !section.classList.contains('gallery-with-text-section')) return;
		const inst = instances.get(section);
		if (inst) {
			inst.destroy();
			instances.delete(section);
		}
		if (sectionObserver) sectionObserver.unobserve(section);
		if (sectionResizeObserver) sectionResizeObserver.unobserve(section);
	});

	initSection();
})();
// custom end
